import { z } from 'zod';
import { emailSchema, roleSchema, uuidSchema } from './common.js';
/** POST /members — invite a colleague into the current org (org_admin). */
export const inviteMemberSchema = z.object({
    email: emailSchema,
    role: z.enum(['user', 'org_admin']).default('user'),
});
/** PATCH /members/:userId — change a member's role (cannot demote the last admin). */
export const patchMemberSchema = z.object({ role: z.enum(['user', 'org_admin']) });
export const memberSchema = z.object({
    userId: uuidSchema,
    email: z.string(),
    role: roleSchema,
    status: z.enum(['invited', 'active']),
    createdAt: z.string(),
});
//# sourceMappingURL=members.js.map